var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94368 0.953785C7.27364 1.28012 7.27657 1.81215 6.95023 2.1421L3.37929 5.7526H20.2502C20.7143 5.7526 21.0905 6.12881 21.0905 6.59288C21.0905 7.05695 20.7143 7.43316 20.2502 7.43316H3.4947L6.95984 11.0535C7.28072 11.3888 7.26907 11.9207 6.93381 12.2416C6.59855 12.5625 6.06664 12.5508 5.74576 12.2156L1.38291 7.65724L1.63664 7.4144L1.38291 7.65724C0.763141 7.00971 0.772234 5.99868 1.40207 5.36187L5.75537 0.960332C6.08171 0.63038 6.61373 0.627449 6.94368 0.953785Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.0df7e22e2bf8a5519c44d112cfb95d46.svg";
export { ForwardRef as ReactComponent };